import styled from 'styled-components'

export const Error = styled.p`
  font-size: 12px;
  color: red;
  margin-top: -10px;
`
